import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[downloadAnimation]',
  standalone: true
})
export class DownloadAnimationDirective {

  @Input() downloadAnimation!: boolean;
  @Input() layoutDark!: boolean;

  spanAnimation = this.createSpan();
  constructor(private elementRef: ElementRef) { 
    if (this.downloadAnimation) {
      this.elementRef.nativeElement.disabled = true;
      this.elementRef.nativeElement.classList.add('downloading');
      
      this.elementRef.nativeElement.appendChild(this.spanAnimation);
    } else {
      // if (this.elementRef?.nativeElement) {
        this.elementRef.nativeElement.disabled = false;
        if (this.elementRef.nativeElement.classList.contains('downloading')) {
          this.elementRef.nativeElement.classList.remove('downloading');
        }
      // }
      const span = this.elementRef.nativeElement.querySelector('.action-downloading');
      if (span) {
        this.elementRef.nativeElement.removeChild(span);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['downloadAnimation'] && changes['downloadAnimation'].currentValue) {
      this.elementRef.nativeElement.appendChild(this.spanAnimation);
      this.elementRef.nativeElement.classList.add('downloading');
      this.elementRef.nativeElement.disabled = true;
    } else {
      // remove the span
      const span = this.elementRef.nativeElement.querySelector('.action-downloading');
      if (span) {
        this.elementRef.nativeElement.classList.remove('downloading');
        this.elementRef.nativeElement.removeChild(span);
      }

      this.elementRef.nativeElement.disabled = false;
    }
  }
  
  createSpan() {
    const span = document.createElement('span');
    let layout = this.layoutDark ? 'layout-dark' : 'layout-light';
    span.classList.add('action-downloading','d-flex','align-items-center', layout);
    return span;
  }

}
